import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Search, Download, User } from "lucide-react";

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/discover", icon: Search, label: "Discover" },
    { path: "/collection", icon: Download, label: "Collection" },
    { path: "/profile", icon: User, label: "Profile" },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="nav-bar">
      {navItems.map((item) => (
        <button
          key={item.path}
          className={`nav-item ${isActive(item.path) ? "active" : ""}`}
          onClick={() => navigate(item.path)}
        >
          <item.icon size={26} />
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default Navigation;